import { styled } from '@mui/material/styles';
import { Box, Card } from '@mui/material';

export const TestimonialsContainer = styled(Box)(({ theme }) => ({
    padding: theme.spacing(5, 2), // Reduced padding overall
    position: 'relative',
    backgroundColor: 'rgba(46, 54, 73, 0.6)',
    backdropFilter: 'blur(15px)',
    borderRadius: '16px',
    [theme.breakpoints.up('md')]: {
        padding: theme.spacing(10, 4), // Restore larger padding on medium screens and up
    },
}));

export const TestimonialCard = styled(Card)(({ theme }) => ({
    position: 'relative',
    padding: theme.spacing(6, 4),
    borderRadius: '12px',
    boxShadow: '0 4px 20px rgba(0, 0, 0, 0.05)',
    backgroundColor: 'rgba(26, 35, 54, 0.6)',
    marginBottom: theme.spacing(4),
    elevation: 10,
}));

export const TestimonialContent = styled(Box)(({ theme }) => ({
    position: 'relative',
    zIndex: 1,
}));

export const TestimonialAuthor = styled(Box)(({ theme }) => ({
    marginTop: theme.spacing(2),
    display: 'flex',
    alignItems: 'center',
}));

export const TestimonialNavigation = styled(Box)(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
}));

export const QuoteIcon = styled(Box)(({ theme }) => ({
    position: 'absolute',
    top: theme.spacing(2),
    left: theme.spacing(2),
    color: theme.palette.primary,
    opacity: 0.2,
    transform: 'scale(2)',
    zIndex: 0,
}));
